import { render, staticRenderFns } from "./VipDialog.vue?vue&type=template&id=33a38bd6&scoped=true"
import script from "./VipDialog.vue?vue&type=script&lang=js"
export * from "./VipDialog.vue?vue&type=script&lang=js"
import style0 from "./VipDialog.vue?vue&type=style&index=0&id=33a38bd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a38bd6",
  null
  
)

export default component.exports